import {useEffect, useState} from "react";
import {UserInfoModel} from "../model/ua/user-info";
import {useAppDispatch, useAppSelector} from "../store/hook";
import {firebaseConfig} from "app/config/firebaseConfig";
import {initializeApp} from "firebase/app";
import {onMessage} from "firebase/messaging";
import {messaging, requestPermission} from "../services/common/Firebase";
import {AppDispatch} from "../store/store";
import {FirebaseService} from "../services/common/FirebaseService";
import {updateAlarmMessages} from "../reducers/alarmSlice";
import {toast} from "react-toastify";

const format = (d: Date): string =>
    new Date(d.getTime() - d.getTimezoneOffset() * 60000)
    .toISOString()
    .replace('T', ' ')
    .substring(0, 19);

const lastMonthDay = new Date();
lastMonthDay.setMonth(lastMonthDay.getMonth() - 1);

type GetMessageParams = { userId: string; month: string };

export async function getMessages(dispatch: AppDispatch, newUserInfo: any) {
  try {
    const param: GetMessageParams = {
      month: format(lastMonthDay),
      userId: newUserInfo.userId,
    };

    const response = await FirebaseService.getInstance().getMessage(param);

    if (response?.data) {
      dispatch(updateAlarmMessages(response.data));
    }
  } catch (error) {
    console.error("메시지를 가져오는 데 실패하였습니다.", error);
  }
}

const app = initializeApp(firebaseConfig)
export default function AuthGuard(props: any) {
  const dispatch = useAppDispatch();
  const userInfo: UserInfoModel = useAppSelector((state) => state.userInfo.userInfo);

  /**
   * isAuthenticated state value should be false
   * temporary set to true to bypass check authenticated
   * **/
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const fetchToken = async () => {
    const token = await requestPermission();
    if (token) {
      await FirebaseService.getInstance().saveDeviceToken({
        uid: userInfo.userId,
        token: token
      });
      getMessages(dispatch, userInfo);
    }
  };

  useEffect(() => {
    if (userInfo?.userId) {
      fetchToken();
      getMessages(dispatch, userInfo); // 로그인 시 알림메세지 호출
    }
  }, [userInfo?.userId]);

  onMessage(messaging, (payload) => {
    if (payload) {
      setTimeout(() => {
        toast.success('새로운 알림이 도착했습니다!');
        getMessages(dispatch, userInfo);
      }, 500);
    }
  });

  return isAuthenticated && props.children;
}
